module.exports = __webpack_public_path__ + "img/new5.c502552d.jpg";